// src/api/auth.js
import apiClient from "../utils/apiClient";

export function login(data) {
  const { user, token } = data;
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('token', token);
  // Notify listeners (e.g. SocketProvider) that auth state changed
  window.dispatchEvent(new Event('vc-auth-change'));
  return { user };
}

/**
 * Unsubscribe from browser push notifications before logout.
 * Removes ALL web push subscriptions for this user on the server.
 * Non-blocking — logout proceeds even if this fails.
 */
async function cleanupPushSubscriptions() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    // Tell server to remove all web push subscriptions for this user
    await apiClient.post('/notifications/push-unsubscribe-all');
    console.log('[Push] Cleaned up web push subscriptions on logout');
  } catch (err) {
    // Non-critical — proceed with logout regardless
    console.warn('[Push] Failed to cleanup push subscriptions on logout:', err.message);
  }
}

export async function logout() {
  // Clean up push subscriptions BEFORE removing the token
  await cleanupPushSubscriptions();

  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('selectedRole');
  window.dispatchEvent(new Event('vc-auth-change'));
}

export function getCurrentUser() {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
}

export function isLoggedIn() {
  return !!localStorage.getItem('user');
}